/* eslint-disable  */
import { useState, useEffect } from 'react';

export const useMobile = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 576);
    useEffect(() => {
        setIsMobile(window.innerWidth <= 576);

        function handleResize() {
            setIsMobile(window.innerWidth <= 576);
        }

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return { isMobile };
};

export const useTablet = () => {
    const [isTablet, setIsTablet] = useState(false);

    useEffect(() => {
        setIsTablet(window.innerWidth <= 991);
        function handleResize() {
            setIsTablet(window.innerWidth <= 991);
        }

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return { isTablet };
};

export const useLarge = () => {
    const [isLarge, setIsLarge] = useState(false);

    useEffect(() => {
        setIsLarge(window.innerWidth <= 1024);
        function handleResize() {
            setIsLarge(window.innerWidth <= 1024);
        }
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return { isLarge };
};
//todo these could probably all do with a refactor to use one helper?
